// eslint-disable-next-line
import React, { Component } from 'react';

import survey from './context/survey';
import resizing from './context/resizing';
import surveyState from './app/surveyState';
import Main from './Main';
import requiredFeaturesAreSupported from './app/requiredFeatures';
import WatchResize from './component/watch-resize/WatchResize';

/**
 * local storage をチェックし必要であればストレージを削除し survey 起動可能か判定します
 * @return {boolean|boolean} true: 起動可能
 * @since 20191210 - embedded type でも使用するために関数化しました
 */
export const shouldClearLocalStorageWithActivate = () => {
  // In case the search query `rexsurvey_save_state=false` in `location.search`:
  //
  // Clear current survey state and expiration time in localStorage, both for (A) and (B)
  // Don't store status into localStorage
  const { enableDisplaySuppressionPerPage } = survey.initial.config;
  const hashStr = surveyState.makeHash(enableDisplaySuppressionPerPage);
  // clear condition
  // 1. !surveyState.shouldStoreState() - /rexsurvey_save_state=false/.test(window.location.search) === false
  // 2. key name が存在し && expire
  if (
    !surveyState.shouldStoreState() ||
    (surveyState.has(hashStr) && surveyState.expire(hashStr))
  ) {
    surveyState.clearAll(hashStr);
  }

  return (
    requiredFeaturesAreSupported() &&
    surveyState.check(enableDisplaySuppressionPerPage)
  );
};

/**
 * survey widget 開始します
 * - config.enableDisplaySuppressionPerPage flag をもとに localstorage check します
 * - expired の時は storage 削除します
 * - query check し `rexsurvey_save_state=false` &&
 * key name (REX-SURVEY-EXPIRATION-TIME with hash) が存在し 表示期限切れの時に storage 削除します
 * - React.context - `Provider` を root に {@link Main} component mount します
 * @return {*} React.node - survey widget
 * @constructor
 * @see https://confluence.rakuten-it.com/confluence/pages/viewpage.action?spaceKey=UEIT&title=PoPAsk%3A+phase2+-+Rule+for+refrain+the+survey+frequency
 */
const Survey = () => {
  // // In case the search query `rexsurvey_save_state=false` in `location.search`:
  // //
  // // Clear current survey state and expiration time in localStorage, both for (A) and (B)
  // // Don't store status into localStorage
  // const { enableDisplaySuppressionPerPage } = survey.initial.config;
  // const hashStr = surveyState.makeHash(enableDisplaySuppressionPerPage);
  // // clear condition
  // // 1. !surveyState.shouldStoreState() - /rexsurvey_save_state=false/.test(window.location.search) === false
  // // 2. key name が存在し && expire
  // if (
  //   !surveyState.shouldStoreState() ||
  //   (surveyState.has(hashStr) && surveyState.expire(hashStr))
  // ) {
  //   surveyState.clearAll(hashStr);
  // }
  //
  // if (requiredFeaturesAreSupported()) {
  //   // localstorage check し起動します
  //   return (
  //     surveyState.check(enableDisplaySuppressionPerPage) && (
  //       <survey.Provider>
  //         <resizing.Provider>
  //           <Main />
  //         </resizing.Provider>
  //       </survey.Provider>
  //     )
  //   );
  // }
  //
  // return null;
  return (
    shouldClearLocalStorageWithActivate() && (
      <survey.Provider>
        <resizing.Provider>
          <WatchResize>
            <Main />
          </WatchResize>
        </resizing.Provider>
      </survey.Provider>
    )
  );
};

export default Survey;



// WEBPACK FOOTER //
// ./src/phase2/survey/index.js